// src/client/game/core/ammo/ConsumePolicy.ts

/**
 * ConsumePolicy decides whether a segment index is eligible to be consumed.
 *
 * The model uses indices where:
 *  - 0 is head
 *  - (tailLength - 1) is tail tip
 */
export interface ConsumePolicy {
  isEligible(segmentIndex: number, tailLength: number): boolean;
}

/**
 * Only allow consuming charges within the last N segments ("dead tail zone").
 * This enforces "don't shoot your clip".
 */
export class DeadTailOnlyPolicy implements ConsumePolicy {
  constructor(private readonly deadTailWindow: number) {}

  isEligible(segmentIndex: number, tailLength: number): boolean {
    const start = Math.max(0, tailLength - this.deadTailWindow);
    return segmentIndex >= start;
  }
}
